import { render, staticRenderFns } from "./GiftCardB2b.vue?vue&type=template&id=99646522&scoped=true&"
import script from "./GiftCardB2b.vue?vue&type=script&lang=js&"
export * from "./GiftCardB2b.vue?vue&type=script&lang=js&"
import style0 from "./GiftCardB2b.vue?vue&type=style&index=0&id=99646522&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99646522",
  null
  
)

export default component.exports